import React, { useEffect, useState } from "react";
import { Link, useParams, Navigate } from "react-router-dom";
import { ArrowLeft, CalendarDays, User } from "lucide-react";
import { publicApi } from "../../admin/adminApi";
import RichText from "../../components/RichText";
import ImageCarousel from "../../components/ImageCarousel";
import useBlogSEO from "../../hooks/useBlogSEO";
import "./Blog.css";
export default function BlogDetail() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);
  useEffect(() => {
    let cancelled = false;
    async function load() {
      setLoading(true);
      setNotFound(false);
      try {
        const data = await publicApi.getBlog(slug);
        if (!cancelled) setPost(data);
      } catch (err) {
        if (!cancelled) {
          if (err.status === 404) setNotFound(true);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    load();
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
    return () => {
      cancelled = true;
    };
  }, [slug]);
  useBlogSEO(post);
  if (notFound) return <Navigate to="/blog" replace />;
  const carouselImages = post?.images?.length ? post.images : post?.coverImage ? [post.coverImage] : [];
  return (
    <main className="blog-post">
      <div className="container blog-post__inner">
        <Link to="/blog" className="blog-post__back">
          <ArrowLeft size={16} /> All Posts
        </Link>
        {loading || !post ? (
          <p>Loading…</p>
        ) : (
          <>
            <header className="blog-post__header">
              {post.category && <span className="blog-card__category">{post.category}</span>}
              <h1>{post.title}</h1>
              <div className="blog-post__meta">
                <span>
                  <User size={14} /> {post.author}
                </span>
                {post.publishedAt && (
                  <span>
                    <CalendarDays size={14} /> {new Date(post.publishedAt).toLocaleDateString()}
                  </span>
                )}
              </div>
            </header>
            {carouselImages.length > 0 && <ImageCarousel images={carouselImages} alt={post.title} />}
            <RichText as="article" profile="full" html={post.content} className="blog-post__content" />
            {post.tags?.length > 0 && (
              <div className="blog-post__tags">
                {post.tags.map((tag) => (
                  <span key={tag} className="blog-post__tag">
                    #{tag}
                  </span>
                ))}
              </div>
            )}
          </>
        )}
      </div>
    </main>
  );
}